import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import { getGoogleSearchUrl } from '../utils';

export default function RelatedKeywordsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                <RelatedKeywordsResult relatedKeywords={result.related_keywords} />

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => <RelatedKeywordsResult relatedKeywords={result.related_keywords} />}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type RelatedKeywordsResultProps = {
    relatedKeywords: string[];
};

function RelatedKeywordsResult({ relatedKeywords }: RelatedKeywordsResultProps) {
    return (
        <>
            {relatedKeywords && relatedKeywords.length > 0 && (
                <div className="description-meta">
                    <ul>
                        {relatedKeywords.map((tag, idx) => (
                            <li key={idx}>
                                <a
                                    href={getGoogleSearchUrl(tag)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {tag}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
}
